@if (footnotes().length > 0) {
    <div class="inner-page-wrapper text-14 text-grey-400 flex flex-col gap-16 bg-white py-24 leading-20 empty:mt-0">
        @for (footnote of footnotes(); track footnote.id) {
            <div class="flex flex-row" [id]="footnote.id">
                <span class="mr-8 font-medium">{{ footnote.sign }}</span>
                <div class="break-word" [innerHTML]="footnote.content"></div>
            </div>
        }
    </div>
}
